import React from 'react'
import { connect } from 'react-redux'
import GalleryCard from './GalleryCard'

const Header = () => (
  <div className="container container-ribbon ribbon-font not-for-ipad">
    <h1 className="ribbon ribbon-banner-color ribbon-font" id="ribbon-banner-content">
      <strong className="ribbon-content ribbon-shadow-color ribbon-font">
        <span className="title title-text ribbon-font">Club Status</span>
      </strong>
    </h1>
  </div>
);

const NoClubsMessage = () => (
  <section className="container center-block no-cards">
    <h1 className="text-center no-club-message">No clubs were found.</h1>
    <div className="img-responsive center-block no-club"></div>
    <p className="lead text-center no-club-message">You have either not purchased any Club items or have redeemed all of your cards.</p>
  </section>
);

const List = ({ clubs }) => (
  <div>
    <section id="cards-container">
      {
        clubs.map( (club, index) => <GalleryCard key={index} index={index} club={club} clubsCount={clubs.length} />)
      }
    </section>
    <div className="clubs-caption text-center"></div>          
  </div>
);

const ClubsList = ({ clubs }) => (
  <div>
  <Header />
    { clubs.length === 0 ?  <NoClubsMessage /> : <List clubs={clubs} /> }
  </div>
);

const stateToProps = state => ({
  clubs: state.clubs
});

export default connect(stateToProps)(ClubsList)


// WEBPACK FOOTER //
// ./src/components/ClubsList.js